export const templateSelectionParams = (broadcast, template, { isBlueprint = false, isTeamBlueprint = false } = {}) => {
  if (isTeamBlueprint || isBlueprint) {
    return {
      broadcast: {
        beefree_template_attributes: {
          id: broadcast.beefree_template.id,
          template: template.template,
          copied_from_blueprint_id: isTeamBlueprint ? template.id : null,
        },
      },
    };
  }

  return {
    broadcast: {
      change_template: template ? template.templatable.id : null,
    },
  };
};
